import { Injectable, inject, signal } from "@angular/core";
import { BaseService, SHOULD_SHOW_ERROR_TOAST, SHOULD_SHOW_SUCCESS_TOAST, SUCCESS_MESSAGE, HttpInterceptorConfig, ErrorMessageType, ERROR_MESSAGE } from "../../core/services/base.service";
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SubscribePayload, SubscriptionResponse } from "./landing-page.interface";
import { NotifResponseItem } from "@/app/consts/notif.const";


@Injectable({ providedIn: 'root' })
export class LandingPageService  {
  private baseService = inject(BaseService)

  private _userSubsTypes = signal<SubscriptionResponse | undefined>(undefined);
  readonly userSubsTypes = this._userSubsTypes.asReadonly();

  constructor() {
    this.fecthUserSubscriptionsTypes();
  }
  fecthUserSubscriptionsTypes(httpInterceptorConfig?: HttpInterceptorConfig): void {
    const context: HttpContext = new HttpContext();
    const {
      shouldShowSucceessToaster = false, 
      successToasterMessage = '', 
      shouldShowErrorToaster = true, 
      errorToasterMessage = [{
        type: 400,
        message: 'Subscriptions not found',
      }, {
        type: 'default',
        message: 'No Subscriptions found',
      }] as ErrorMessageType[],
    } = httpInterceptorConfig || {};

    context.set(SHOULD_SHOW_SUCCESS_TOAST, shouldShowSucceessToaster);
    if(shouldShowSucceessToaster) context.set(SUCCESS_MESSAGE, successToasterMessage);

    context.set(SHOULD_SHOW_ERROR_TOAST, shouldShowErrorToaster);
    if(shouldShowErrorToaster) context.set(ERROR_MESSAGE, errorToasterMessage);

    this.baseService.get<SubscriptionResponse>(`notification/user`, undefined, undefined, context).subscribe({
      next: (result) => {
        this._userSubsTypes.set(result || undefined);
      },
      error: (error) => {
        console.error(error)
      }
    });
  }

  fetchNotificationListForUserSide() {
    const payload = {
      "Information":false,
      "Failures":false,
      "Warnings":false,
      "Updates":false
    }
    const context: HttpContext = new HttpContext();

    context.set(SHOULD_SHOW_SUCCESS_TOAST, false);

    context.set(SHOULD_SHOW_ERROR_TOAST, false);
    // context.set(ERROR_MESSAGE, [{ type: 'default', message: 'Notifications not found' }]);
    return this.baseService.post<NotifResponseItem[]>(`notification/user/list`, payload, undefined, context);
  }

  subscribeNotificationEmail(payload: SubscribePayload) {
    return this.baseService.post(`notification/user`, payload);
  }
}
